import styled, { css } from "styled-components";

export const PopoverWrapper = styled.div`
  position: relative;
  transform-origin: left;
  margin-left: 8px;
  pointer-events: none;
`;

export const PopoverContainer = styled.div`
  padding: 12px;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.base};
  background: ${({ theme }) => theme.colors.default[900]};
  font-size: 12px;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0.36px;
  position: relative;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  max-width: 240px;
`;

export const PopoverOverWrapper = styled.div``;

export const Arrow = styled.div<{
  $position: "left" | "right" | "top" | "bottom";
}>`
  position: absolute;
  content: "";
  background: ${({ theme }) => theme.colors.default[900]};
  width: 11px;
  height: 11px;
  z-index: 0;
  ${({ $position }) => {
    switch ($position) {
      case "right":
        return css`
          top: 50%;
          left: -5px;
          transform: translateY(-50%) rotate(45deg);
        `;
      case "left":
        return css`
          top: 50%;
          right: -5px;
          transform: translateY(-50%) rotate(225deg);
        `;
      case "bottom":
        return css`
          top: -5px;
          left: 50%;
          transform: translateX(-50%) rotate(315deg);
        `;
      case "top":
        return css`
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%) rotate(135deg);
        `;
    }
  }}
`;
